/**
 * @generated SignedSource<<21bd8a1627dfb7e77c232fd7f13c2cff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type TeamAdmin_Team$data = {
  readonly icon: TeamIcon | null;
  readonly id: string;
  readonly isArchived: boolean;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  readonly " $fragmentType": "TeamAdmin_Team";
};
export type TeamAdmin_Team$key = {
  readonly " $data"?: TeamAdmin_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamAdmin_Team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamAdmin_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamIconCircleComponent_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "524408def757e23ca102597cfc4ef284";

export default node;
